/**
 * Lot AL5 — seuil d'attente d'un portail, écrit UNE SEULE FOIS pour tout le front.
 *
 * La mention « Sans réponse du portail depuis X » est née dans la modale de diffusion
 * (lot AD2) ; l'écran /diffusion en a besoin aussi, et le backend s'appuie sur le même seuil
 * pour lever la garde `depot_en_cours` (lot AL2, `diffusion_service.SEUIL_ATTENTE_HEURES`).
 * Trois copies du « 24 » divergeraient : il n'y en a qu'une ici, et une côté serveur.
 */
export const SEUIL_ATTENTE_H = 24;

/**
 * Durée d'attente lisible depuis la date de DÉPÔT, ou null en dessous du seuil.
 * ⚠️ Toujours `date_depot` (lot AD2) : `date` est réécrite à chaque « Rafraîchir le statut »
 * et ferait croire que l'attente vient de commencer.
 */
export const attenteDepuis = (dateDepot) => {
  if (!dateDepot) return null;
  const depot = new Date(dateDepot);
  if (Number.isNaN(depot.getTime())) return null;
  const heures = (Date.now() - depot.getTime()) / 3600000;
  if (heures < SEUIL_ATTENTE_H) return null;
  const jours = Math.floor(heures / 24);
  return jours >= 1
    ? `${jours} jour${jours > 1 ? 's' : ''}`
    : `${Math.floor(heures)} heures`;
};

/** Le portail est-il muet au-delà du seuil ? (mêmes conditions que la levée de garde AL2) */
export const estSansReponse = (etat) => (
  etat?.status === 'en_attente' && attenteDepuis(etat?.date_depot) !== null
);

/**
 * Lot BM — le portail notifie tout seul : l'écran relit NOTRE api pendant qu'il traite.
 * ⛔ Lot BP — le seuil de 30 minutes qui masquait « Rafraîchir le statut » a été SUPPRIMÉ :
 * c'est le geste qui débloque une attente, il ne doit pas se cacher. Le bouton s'affiche dès
 * qu'un `classified_id` existe.
 */
/** Lot BM — relecture de NOTRE api pendant que le portail traite : 30 s, 10 min au plus. */
export const RELECTURE_MS = 30000;
export const RELECTURE_DUREE_MAX_MS = 10 * 60 * 1000;
